import { PropsWithChildren } from 'react'
import styles from './DataBlock.module.scss'
import { DataBlockProps } from './types'
import classNames from 'classnames'

const DataBlock = ({ label, withMargin = true, children }: PropsWithChildren<DataBlockProps>) => (
  <div className={styles['data-block']}>
    {label && <strong className={classNames({ ['mb-200']: withMargin })}>{label}</strong>}
    {children}
  </div>
)

export default DataBlock
